module.exports = __webpack_public_path__ + "static/img/video3.437ad37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video3.png
// module id = SCZZ
// module chunks = 0